import { useEffect } from "react";

const BimiLogo = () => {
  useEffect(() => {
    // Set the correct MIME type via meta (informational)
    document.title = "BIMI Logo";
  }, []);

  return (
    <div style={{ margin: 0, padding: 0, background: "none" }}>
      <img
        src="/readdy-assets/static-b0d72ee7c49b00bf1f17c9b71fdde6bc.svg"
        alt="Dino Nuggets BIMI Logo"
        style={{ display: "block", width: "100%", height: "auto" }}
      />
    </div>
  );
};

export default BimiLogo;
